import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

type AccessErrorScreenProps = {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
};

const AccessErrorScreen: React.FC<AccessErrorScreenProps> = ({
  title = 'Something went wrong',
  message,
  onRetry,
  retryLabel = 'Try again',
}) => {
  return (
    <div className="min-h-screen bg-dark-950 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-red-500/15 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-red-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.314 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-white mb-3">{title}</h1>
        <p className="text-gray-300 text-sm mb-8 leading-relaxed">{message}</p>
        <div className="space-y-3">
          {onRetry && (
            <Button type="button" onClick={onRetry}>
              {retryLabel}
            </Button>
          )}
          <Link
            to="/contact"
            className="block text-sm text-emerald-400 hover:text-emerald-300 transition-colors"
          >
            Contact support
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccessErrorScreen;
